module.exports = __webpack_public_path__ + "static/img/baseData.e315dad1.png";